import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { 
  Container, 
  Paper, 
  Title, 
  Text, 
  Button, 
  Stack,
  Center,
  Box
} from '@mantine/core';
import { IconLogin, IconUserPlus } from '@tabler/icons-react';
import Logo from './images/logobw.svg';

const AuthPage = () => {
  const { loginWithRedirect } = useAuth0();

  const handleSignIn = () => {
    loginWithRedirect();
  };

  const handleSignUp = () => {
    loginWithRedirect({ screen_hint: 'signup' });
  };

  return (
    <Box
      style={{
        minHeight: '100vh',
        background: '#f8f9fa',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}
    >
      <Container size="sm">
        <Center>
          <Paper
            radius={0}
            p={60}
            shadow="sm"
            style={{
              width: '100%',
              maxWidth: '480px',
              background: '#ffffff',
              border: '1px solid #e9ecef'
            }}
          >
            <Stack align="center" spacing={40}>
              {/* Logo */}
              <Box style={{ marginBottom: '20px' }}>
                <img 
                  src={Logo} 
                  alt="RiskGPT" 
                  style={{ 
                    height: '48px',
                    width: 'auto'
                  }} 
                />
              </Box>

              {/* Content */}
              <Stack align="center" spacing={16}>
                <Title
                  order={1}
                  size={32}
                  style={{
                    color: '#212529',
                    fontWeight: 600,
                    textAlign: 'center',
                    letterSpacing: '-0.02em',
                    lineHeight: 1.2
                  }}
                >
                  Welcome to RiskGPT
                </Title>
                
                <Text
                  size={16}
                  style={{ 
                    textAlign: 'center', 
                    maxWidth: '360px',
                    color: '#6c757d',
                    lineHeight: 1.5,
                    fontWeight: 400
                  }}
                >
                  AI-powered risk assessment and management platform
                </Text>
              </Stack>

              {/* Buttons */}
              <Stack spacing={12} style={{ width: '100%', maxWidth: '320px' }}>
                <Button
                  size="md"
                  radius={0}
                  leftIcon={<IconLogin size={18} />}
                  onClick={handleSignIn}
                  style={{ 
                    width: '100%',
                    height: '48px',
                    backgroundColor: '#212529',
                    border: 'none',
                    color: '#ffffff',
                    fontWeight: 500,
                    fontSize: '15px'
                  }}
                  styles={{
                    root: {
                      '&:hover': {
                        backgroundColor: '#495057'
                      }
                    }
                  }}
                >
                  Sign In
                </Button>
                
                <Button
                  size="md"
                  radius={0}
                  leftIcon={<IconUserPlus size={18} />}
                  onClick={handleSignUp}
                  variant="outline"
                  style={{ 
                    width: '100%',
                    height: '48px',
                    borderColor: '#dee2e6',
                    color: '#495057',
                    fontWeight: 500,
                    fontSize: '15px'
                  }}
                  styles={{
                    root: {
                      '&:hover': {
                        backgroundColor: '#f8f9fa',
                        borderColor: '#adb5bd'
                      }
                    }
                  }}
                >
                  Sign Up
                </Button>
              </Stack>

              {/* Footer */}
              <Text 
                size={13} 
                style={{ 
                  textAlign: 'center',
                  color: '#adb5bd',
                  fontWeight: 400
                }}
              >
                Secure authentication powered by Auth0
              </Text>
            </Stack>
          </Paper>
        </Center>
      </Container>
    </Box>
  );
};

export default AuthPage;